<template>
  <!-- Хлебные крошки по ТЗ: Главная → Блог → Тема → Статья.
       Микроразметку BreadcrumbList отдаём отдельно в JSON-LD страницы.
       В макетах ленты и статьи разное оформление, отсюда variant. -->
  <nav
    aria-label="Хлебные крошки"
    class="flex flex-wrap items-center gap-2 text-sm leading-[normal]"
  >
    <template v-for="(item, index) in items" :key="item.url">
      <!-- w-fit обязателен: меню в лейауте объявляет не-scoped `a { width: 100% }`,
           из-за чего ссылки растягиваются и крошки встают столбиком -->
      <NuxtLink
        v-if="index < items.length - 1"
        :to="item.url"
        class="w-fit shrink-0 whitespace-nowrap transition-colors hover:text-primary"
        :class="isArticle ? 'text-txmain' : 'text-txopacity'"
      >
        {{ item.name }}
      </NuxtLink>
      <span
        v-else
        class="min-w-0 truncate"
        :class="isArticle ? 'text-txopacity' : 'font-medium text-primary'"
      >
        {{ item.name }}
      </span>
      <span v-if="index < items.length - 1" class="shrink-0 text-txopacity">
        {{ isArticle ? "→" : "/" }}
      </span>
    </template>
  </nav>
</template>

<script setup lang="ts">
  export interface Crumb {
    name: string;
    url: string;
  }

  const props = withDefaults(
    defineProps<{ items: Crumb[]; variant?: "feed" | "article" }>(),
    { variant: "feed" }
  );

  const isArticle = computed(() => props.variant === "article");
</script>
